module.exports = __webpack_public_path__ + "static/lights19-03182e1be954fc3a2e593d7bea41f3bd.jpg";